import { Unit } from "./Unit";
import { getRandomInt } from "./utils";


export interface SoloOptions {
    useCost590: boolean;
    useCost560: boolean;
    useCost450: boolean;
    useCost420: boolean;
    useCost280: boolean;
    useCost270: boolean;
    useCost200: boolean;
}

export namespace Solo {

    export function random(options: SoloOptions): Unit {
        const units = Unit.getAll();

        for (let i = 0; i < 10000; i++) {
            const p1 = units[getRandomInt(units.length)];

            if (!options.useCost200 && p1.cost === 200) {
                continue;
            }

            if (!options.useCost270 && p1.cost === 270) {
                continue;
            }

            if (!options.useCost280 && p1.cost === 280) {
                continue;
            }

            if (!options.useCost420 && p1.cost === 420) {
                continue;
            }

            if (!options.useCost450 && p1.cost === 450) {
                continue;
            }

            if (!options.useCost560 && p1.cost === 560) {
                continue;
            }

            if (!options.useCost590 && p1.cost === 590) {
                continue;
            }

            return p1;
        }

        throw new Error(``);

    }
}
